import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import queryString from 'query-string';

import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import { DISPLAY_SEGMENT_TYPE, SEGMENT_TYPE } from 'config/CustomEnums';

function Filter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search.slice(1));
  const showInCustomerProfileParsed = parsedSearch['show_in_customer_profile'] || '';
  const segmentTypeParsed = parsedSearch['type'] || '';

  const [showInCustomerProfile, setShowInCustomerProfile] = useState(showInCustomerProfileParsed);
  const [segmentType, setSsegmentType] = useState(segmentTypeParsed);

  const content = [
    {
      title: 'Type',
      data: [
        { name: DISPLAY_SEGMENT_TYPE?.[SEGMENT_TYPE.DYNAMIC], pk: SEGMENT_TYPE.DYNAMIC },
        { name: DISPLAY_SEGMENT_TYPE?.[SEGMENT_TYPE.STATIC], pk: SEGMENT_TYPE.STATIC },
      ],
      value: segmentType,
      setValue: setSsegmentType,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
    {
      title: 'Show in customer profile',
      data: [
        { name: 'Yes', pk: 'true' },
        { name: 'No', pk: 'false' },
      ],
      value: showInCustomerProfile,
      setValue: setShowInCustomerProfile,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
